import {
    DXP_SEARCH_GET,
    DXP_SEARCH_GET_ERROR,
    DXP_SEARCH_SELECT,
    DXP_SEARCH_ADD,
    DXP_SEARCH_ADD_ERROR,
    DXP_SEARCH_UPDATE,
    DXP_SEARCH_UPDATE_ERROR,
    DXP_SEARCH_DELETE,
    DXP_SEARCH_DELETE_ERROR,
} from "../actions/types";

const initialState = {
    count: null,
    featuredContent: [],
    selectedContent: null,
    isLoading: true,
    success: false,
};

export default function (state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case DXP_SEARCH_GET:
            return {
                ...state,
                featuredContent: payload,
                isLoading: false,
                success: true,
            };
        case DXP_SEARCH_SELECT:
            return {
                ...state,
                selectedContent: payload,
                isLoading: false,
                success: true,
            };
        case DXP_SEARCH_ADD:
        case DXP_SEARCH_UPDATE:
        case DXP_SEARCH_DELETE:
            return {
                ...state,
                isLoading: false,
                success: true,
            };
        case DXP_SEARCH_GET_ERROR:
            return {
                ...state,
                featuredContent: payload,
                isLoading: false,
                success: true
            }
        case DXP_SEARCH_ADD_ERROR:
        case DXP_SEARCH_UPDATE_ERROR:
        case DXP_SEARCH_DELETE_ERROR:
            return {
                ...state,
                isLoading: false,
                success: true
            }
        default:
            return state;
    }
}
